import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Table,
  CardTitle,
  FormGroup,
  Input,
  Badge,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  CustomInput,
} from "reactstrap";
import {
  AGENCY_USER_LIST_URL,
  USER_DETAILS_URL,
  USER_DELETE_URL,
  AGENCY_USER_UPDATE_URL,
  AGENCY_USER_CREATE_URL,
} from "../../utils/APIEndpoints";
import {
  authHeader,
  loggedUserDetails,
} from "../../utils/functions/CoreFunctions";
import API from "../../redux/actions/API";
import {
  SingleStringFirstLetterCaps,
  getAlertToast,
  getConfirm,
  getCurrentAgencyId,
  getCurrentUserId,
} from "../../utils/functions/CustomFunctions";
import CustomViewButton from "../common/CustomViewButton";
import CustomTableLoader from "../common/CustomTableLoader";
import CustomTableEmptyRecord from "../common/CustomTableEmptyRecord";
import CustomTableHeader from "../common/CustomTableHeader";
import CustomUserAvatar from "../common/CustomUserAvatar";
import CustomEditButton from "../common/CustomEditButton";
import CustomDeleteButton from "../common/CustomDeleteButton";
import Create from "./create";
import View from "./view";
import Swal from "sweetalert2";
import Pagination from "react-js-pagination";
import { debounce } from "underscore";
import { SET_AGENCY_USER_PROFILE_PICTURE } from "../../redux/actions/ActionTypes";
import { useDispatch } from "react-redux";

//Table Columns
const tableColumns = [
  { title: "Profile" },
  { title: "First Name" },
  { title: "Last Name" },
  { title: "Email" },
  { title: "Phone Number" },
  { title: "Role" },
  { title: "Notify Email" },
  { title: "Actions" },
];

const Users = (props) => {
  const dispatch = useDispatch();
  const { userId: loggedUser } = loggedUserDetails();
  //State
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createModal, setCreateModal] = useState();
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    address: "",
  });
  const [isAdd, setIsAdd] = useState(false);
  const createToggle = () => setCreateModal(!createModal);
  const [viewModal, setViewModal] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(0);
  const [isActive, setIsActive] = useState(false);
  let id = getCurrentAgencyId();
  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    count: 10,
  });

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  // useEffect(() => {
  //   getGridData({
  //     ...filter,
  //     count: rowsPerPage || undefined,
  //     offset: currentPage,
  //     agencyId: id,
  //   });
  // }, [rowsPerPage]);

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          // count: rowsPerPage || undefined,
          offset: currentPage,
          agencyId: id,
        }),
      500
    )
  ).current;

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter((val) => ({ ...val, [name]: value }));
  };

  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      role: "",
    }));
  };

  const viewToggle = () => setViewModal(!viewModal);

  const rowperpageHandel = (e) => {
    const { value, name } = e.target;
    setCurrentPage(0);
    setFilter((val) => ({ ...val, [name]: value || undefined }));
  };

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
      agencyId: id,
    });
  };

  const viewRecord = async (userId, e) => {
    setCurrentUserId(userId);
    setViewModal(true);
  };

  const saveCallBack = () => {
    getGridData({
      ...filter,
      // count: rowsPerPage || undefined,
      offset: currentPage,
      agencyId: id,
    });
    createToggle(false);
  };
  const createRecord = async () => {
    setUserData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      role: "",
      address: "",
    });
    setIsAdd(true);
    setCreateModal(true);
    dispatch({
      type: SET_AGENCY_USER_PROFILE_PICTURE,
      payload: "",
    });
  };

  //Get Grid Data
  const getGridData = async (queryParams) => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: AGENCY_USER_LIST_URL,
        headers: authHeader(),
        params: queryParams,
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        let dataToDis = initialResponse.map((record) => {
          let { firstName, lastName } = record;
          let formattedData = {
            firstName: SingleStringFirstLetterCaps(firstName),
            lastName: SingleStringFirstLetterCaps(lastName),
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setTotalRecords(dataToDis.length);
        setGridData(dataToDis);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Edit Record
  const editRecord = async (userId, event) => {
    setLoading(true);
    const options = {
      method: "GET",
      url: USER_DETAILS_URL,
      headers: authHeader(),
      params: { userId },
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        setIsAdd(false);
        setUserData(response.data);
        setCreateModal(true);
        dispatch({
          type: SET_AGENCY_USER_PROFILE_PICTURE,
          payload: response.data.profileImage,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Delete Record
  const deleteRecord = async (userId, e) => {
    Swal.fire(
      getConfirm("warning", "Are you sure do you want to delete?")
    ).then((result) => {
      if (result.value) {
        deleteUser(userId);
      }
    });
  };

  const deleteUser = async (userId) => {
    try {
      setLoading(true);
      const options = {
        method: "DELETE",
        url: USER_DELETE_URL,
        headers: authHeader(),
        params: { userId },
      };
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        getGridData({
          ...filter,
          offset: currentPage,
          agencyId: id,
        });
        Swal.fire(getAlertToast("success", "Record removed successfully"));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const statusChange = async (e, record) => {
    const id = e.currentTarget.dataset.uniqueid;
    // console.log("Id", id, record);
    const { value } = e.target;

    setLoading(true);
    const options = {
      method: "PUT",
      url: AGENCY_USER_UPDATE_URL,
      headers: authHeader(),
      data: {
        ...record,
        isEmailNotify: value === "false" ? true : false,
      },
    };
    try {
      const response = await API(options);
      const { status, message } = response.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
        getGridData({
          ...filter,
          // count: rowsPerPage || undefined,
          offset: currentPage,
          isEmailNotify: isEmailNotify,
          agencyId: record.agencyId,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const { firstName, lastName, email, phoneNumber, role, isEmailNotify } =
    filter;

  return (
    <Fragment>
      <Card body className="mt-5">
        <div className="tableTitleBg mb-4">
          <CardTitle className=" " style={{ margin: "0" }}>
            {" "}
            Users{" "}
          </CardTitle>
          <i
            className="fas fa-filter"
            style={{
              float: "right",
              margin: "0px 7px 3px 16px",
              fontSize: "19px",
              cursor: "pointer",
            }}
            onClick={filterToggle}
          ></i>
          <Button className="f-r" color="primary" onClick={createRecord}>
            <i className="fas fa-user-plus"></i> New User
          </Button>
        </div>
        {isFilterOpen && (
          <Row form className="mb-4">
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={changeFilterField}
                  value={firstName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  onChange={changeFilterField}
                  value={lastName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="email"
                  placeholder="Email"
                  onChange={changeFilterField}
                  value={email}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>+1</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    onChange={changeFilterField}
                    value={phoneNumber}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="select"
                  name="role"
                  placeholder="Role"
                  onChange={changeFilterField}
                  value={role}
                >
                  <option value={""}>-- Show All Roles --</option>
                  <option value={"Merchant Admin"}>Merchant Admin</option>
                  <option value={"Merchant Manager"}>Merchant Manager</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <div style={{ marginTop: "4px" }}>
                <Button color="danger" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Table responsive hover>
          {/* Table Header */}
          <CustomTableHeader tableColumns={tableColumns} />
          {/* Table Header */}
          <tbody>
            {loading ? (
              // Table Loader
              <CustomTableLoader columnsCount={tableColumns.length} />
            ) : (
              // Table Loader
              <Fragment>
                {!gridData.length ? (
                  //  Empty Record
                  <CustomTableEmptyRecord columnsCount={tableColumns.length} />
                ) : (
                  //  Empty Record
                  <Fragment>
                    {gridData.map((record, key) => {
                      return (
                        <tr key={`record_key_${key}`}>
                          <td>
                            {/* Custom Avatar */}
                            <CustomUserAvatar srcPath={record.profileImage} />
                            {/* Custom Avcatar */}
                          </td>
                          <td>{record.firstName}</td>
                          <td>{record.lastName}</td>
                          <td>{record.email}</td>
                          <td>(+1) {record.phoneNumber}</td>
                          <td>
                            <Badge
                              color={
                                record.role === "Merchant Admin"
                                  ? "primary"
                                  : "secondary"
                              }
                            >
                              {record.role}
                            </Badge>
                          </td>
                          {/* <td>(+1) {record.notifications}</td> */}
                          <td>
                            <CustomInput
                              type="switch"
                              id={record.userId}
                              name="customSwitch"
                              value={record.isEmailNotify}
                              checked={record.isEmailNotify}
                              data-uniqueid={record.userId}
                              onChange={(e) => statusChange(e, record)}
                            />
                          </td>
                          <td>
                            {/* Custom View Button  */}
                            <CustomViewButton
                              keyvalue={key}
                              data-user_id={record.userId}
                              onClick={(e) => viewRecord(record.userId, e)}
                            />
                            {/* Custom View Button  */}

                            {/* Custom Edit Button  */}
                            <CustomEditButton
                              keyvalue={key}
                              data-user_id={record.userId}
                              onClick={(e) => editRecord(record.userId, e)}
                            />
                            {/* Custom Edit Button  */}

                            {/* Custom Remove Button  */}
                            {parseInt(record.userId) !==
                              parseInt(loggedUser) && (
                              <CustomDeleteButton
                                keyvalue={key}
                                data-user_id={record.userId}
                                onClick={(e) => deleteRecord(record.userId, e)}
                              />
                            )}
                            {/* Custom Remove Button  */}
                          </td>
                        </tr>
                      );
                    })}
                  </Fragment>
                )}
              </Fragment>
            )}
          </tbody>
        </Table>
        {gridData.length ? (
          <div className="d-flex py-4 justify-content-end space_between">
            <div className="space_between">
              <div>
                <p className="per_page">Records/Page</p>
              </div>
              <div>
                <FormGroup>
                  <Input
                    className="pagi_drop"
                    type="select"
                    name="count"
                    onChange={rowperpageHandel}
                    value={filter.count}
                  >
                    <option value={""}>Show All</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Input>
                </FormGroup>
              </div>
            </div>
            {filter.count && (
              <div>
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentPage + 1}
                  itemsCountPerPage={filter.count}
                  totalItemsCount={totalRecords}
                  onChange={onPageChanged}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Card>
      {/* create Modal */}
      {createModal && (
        <Create
          modal={createModal}
          toggle={createToggle}
          data={userData}
          isAdd={isAdd}
          saveCallBack={saveCallBack}
        />
      )}
      {/* end create Modal */}

      {/* View Dialog */}
      {viewModal && (
        <View
          userId={currentUserId}
          viewToggle={viewToggle}
          viewModal={viewModal}
        />
      )}
      {/* View Dialog */}
    </Fragment>
  );
};

export default Users;
